import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import FrameIsolation from './FrameIsolation';

class Frame extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    maxSize: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.asRenderFrameContainer = false;
  }

  componentDidMount() {
    this.renderFrameContainer();
  }

  componentDidUpdate() {
    this.renderFrameContent();
  }

  componentWillUnmount() {
    if (this.domNode) {
      const w = this.getFrameContainer();
      if (w) {
        ReactDOM.unmountComponentAtNode(w);
      }
    }
  }

  getFrameWindow = () => {
    if (this.domNode) {
      return this.domNode.contentDocument || this.domNode.contentWindow.document;
    }
    return null;
  }

  getDocumentWindow = (doc) => {
    return doc.parentWindow || doc.defaultView;
  }

  getFrameContainer = () => {
    let frame = this.getFrameWindow();

    if (frame && this.asRenderFrameContainer) {
      return frame.getElementById('codai-isolation-frame');
    }
    return null;
  }

  renderFrameContainer = () => {
    if (this.asRenderFrameContainer) {
      return;
    }

    let frame = this.getFrameWindow();
    if (frame && frame.readyState === 'complete' && frame.body.innerHTML === '') {
      this.asRenderFrameContainer = true;
      frame.body.innerHTML = `
      <link rel="stylesheet" href="/style/frame-isolation.css" >
<link rel="stylesheet" href="/style/katex.min.css" >
<link rel="stylesheet" href="/style/devops-markdown.css" >
<div id="codai-isolation-frame">

</div>`;
      this.renderFrameContent();
      // does not work since the document as no requested doc
      //this.getDocumentWindow(frame).onload = () => { this.renderFrameContent(); };
      //this.getDocumentWindow(frame).onresize = this.fitFrameToContent;
    } else {
      setTimeout(this.renderFrameContainer, 60);
    }
  }

  fitFrameToContent = (e) => {
    if (!this.domNode) {
      return;
    }
    this.domNode.height = e.clientHeight + 1;
    [100, 222, 500, 1000, 1700, 5000].forEach(t => {
      setTimeout(() => {
        if (!this.domNode) {
          return;
        }
        let size = e.clientHeight + 1;
        if (this.props.maxSize && size > this.props.maxSize) {
          size = this.props.maxSize;
        }

        this.domNode.height = size;
      }, t);
    });
  }

  renderFrameContent = () => {
    let container = this.getFrameContainer();
    if (container) {
      ReactDOM.render((
        <FrameIsolation renderCallback={(n) => { this.fitFrameToContent(n); }}>
          {this.props.children}
        </FrameIsolation>
      ), container);
    }
  }

  render() {
    return (
      <iframe
        title="codai frame"
        className="codai-frame"
        ref={(n) => { this.domNode = n; }}
        src=""
        scrolling="no"
        {...(this.props.maxSize ? { style: { maxHeight: this.props.maxSize } } : {})}
      />
    );
  }
}

export default Frame;
